<app-admin-header></app-admin-header>
<article class="d-flex flex-column">
    <app-header></app-header>
    <app-unauthorized-error
        *ngIf="errorCode === ErrorCode.Error401 || errorCode === ErrorCode.Error403"
        [errorCode]="errorCode"
        [learningObjects]="learningObjects"
        [nextURL]="nextURL"
        [showContent]="errorCode === ErrorCode.Error403"
        [subjects]="subjects"
        class="d-block h-100 pt-8 pb-4"
    ></app-unauthorized-error>
    <app-not-found-error
        *ngIf="errorCode === ErrorCode.Error404"
        [learningObjects]="learningObjects"
        [subjects]="subjects"
        class="d-block h-100 pt-8 pb-4"
    ></app-not-found-error>
    <app-internal-server-error
        *ngIf="errorCode === ErrorCode.Error500"
        [subjects]="subjects"
        class="d-block h-100 pt-8 pb-4"
    ></app-internal-server-error>
    <app-footer></app-footer>
</article>
